type SeekableMediaElement = Pick<HTMLMediaElement, 'currentTime' | 'pause' | 'play' | 'playbackRate'> & {
  seekable?: TimeRanges
}

export const applyAspectRatio = (
  container: HTMLElement | null,
  media: { videoWidth?: number; videoHeight?: number }
): void => {
  if (!container) {
    return
  }
  const { videoWidth, videoHeight } = media
  if (!videoWidth || !videoHeight) {
    return
  }
  container.style.setProperty('--video-aspect-ratio', `${videoWidth} / ${videoHeight}`)
}

export const getMediaEventCurrentTime = (event: Event): number | undefined => {
  const target = event.currentTarget
  if (!target || typeof target !== 'object' || !('currentTime' in target)) {
    return undefined
  }

  const currentTime = target.currentTime
  return typeof currentTime === 'number' ? currentTime : undefined
}

const getSeekableWindow = (media: SeekableMediaElement): { start: number; end: number } | null => {
  const { seekable } = media
  if (!seekable || seekable.length === 0) {
    return null
  }

  return {
    start: seekable.start(0),
    end: seekable.end(seekable.length - 1),
  }
}

export const canSeekToTime = (media: SeekableMediaElement, timeSeconds: number): boolean => {
  const seekableWindow = getSeekableWindow(media)
  if (!seekableWindow) {
    return true
  }

  return timeSeconds >= seekableWindow.start && timeSeconds <= seekableWindow.end
}

export const getMuxLoopStartTime = (media: SeekableMediaElement, startSeconds?: number): number => {
  if (startSeconds !== undefined && canSeekToTime(media, startSeconds)) {
    return startSeconds
  }

  return getSeekableWindow(media)?.start ?? 0
}
